import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

type Direction = 'up' | 'right' | 'down' | 'left';

const transforms: Record<Direction, string> = {
  up: 'rotate(-90deg)',
  right: 'rotate(0deg)',
  down: 'rotate(90deg)',
  left: 'rotate(180deg)',
};

export type ArrowBigProps = SVGDefaultProps & {
  direction: Direction;
};

export const ArrowBig = ({
  size = 16,
  title = 'Arrow',
  direction = 'right',
  fill = colors.silverSandAlt,
}: Partial<ArrowBigProps>) => {
  const height = Number(size) * 2.85;

  const styles = {
    transform: transforms[direction],
    transition: '0.2s',
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 16.4 27.41" style={styles}>
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M16.4,13.68,13.71,11,3.28.55A2,2,0,0,0,.56.55a1.93,1.93,0,
0,0,0,2.72h0L11,13.69.59,24.13a1.92,1.92,0,1,0,2.72,2.72h0l10.4-10.44Z
`}
        fill={fill}
      />
    </svg>
  );
};
